<form [formGroup]="formGroup">

  <div class="add-group">
    <p class="group-title">THÔNG TIN KHÁCH HÀNG</p>
    <div class="form-group row">
      <div class="col-md-5">
        <label class="label-common">Tên Trạm</label>
      </div>
      <div class="col-md-12">
        <span>{{stationName}}</span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Mã KH" [required]="true" formControlName="customerCode"></dcu-input-text>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Tên KH" formControlName="customerName"></dcu-input-text>
      </div>
    </div>
  </div>

  <div class="add-group">
    <p class="group-title">THÔNG TIN TÀI KHOẢN ĐĂNG NHẬP</p>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Tên đăng nhập" [disabled]="isEdit" [required]="true" formControlName="userName"></dcu-input-text>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Mật khẩu" [required]="true" formControlName="password"></dcu-input-text>
      </div>
    </div>
  </div>

  <div class="add-group">
    <p class="group-title">THÔNG TIN CÔNG TƠ</p>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Mã công tơ" formControlName="meterCode" [required]="true"></dcu-input-text>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-select [required]="true" [customLabel]="'Chọn kiểu công tơ'" [dropdownList]="meterSampleSelect" formControlName="meterSample" label="Kiểu công tơ"></dcu-select>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Mã điểm đo" [required]="true" formControlName="measuringPointCode"></dcu-input-text>
      </div>
    </div>

  </div>
</form>
